<template>
  <span>
    <input type="checkbox" v-model="checked" :checked="checked" class="fct-checkbox" id="cb-head" @change="check($event)">
    <label for="cb-head"></label>
  </span>
</template>

<script>

export default {
  props: ['appScope'],
  data () {
    return {
      checked: false
    }
  },
  methods: {
    check (e) {
      console.log(e.target.checked)
      this.appScope.filteredData.forEach(r => {
        this.$set(r, '_checked', e.target.checked)
      })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
